import { Checkbox, Flex, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { MdClose } from 'react-icons/md'
import Modal from 'react-modal'
import { ButtonCmp } from '../../../../../../components/ButtonCmp'
import { Container, Header } from '../InativarColaborador/styles'

export interface iFiltroCsv {
  ativos: boolean
  inativos: boolean
  desligados: boolean
}

interface iModalProps {
  onRequestClose: () => void
  onConfirm: (filtro: iFiltroCsv) => void
  isLoading: boolean
}

export const ModalBaixarCsv: React.FC<iModalProps> = ({ onRequestClose, onConfirm, isLoading }) => {
  const [Filtro, setFiltro] = useState<iFiltroCsv>({ ativos: true, inativos: false, desligados: false })

  return (
    <Modal
      isOpen
      onRequestClose={onRequestClose}
      overlayClassName='react-modal-overlay'
      className={'react-modal-content-scroll'}
    >
      <Container width={'30rem'}>
        <Header>
          <Flex width={'100%'} justifyContent={'center'}>
            <h3>Baixar CSV da base</h3>
          </Flex>
          <Flex>
            <MdClose size={24} onClick={onRequestClose} />
          </Flex>
        </Header>
        <Flex p={'1rem'} flexDir='column' gap={'1rem'}>
          <Text fontFamily={'Roboto'} fontWeight={'700'} fontSize={'0.875rem'}>
            Selecione quais colaboradores devem constar no arquivo:
          </Text>

          <Flex flexDir='column' gap={'.5rem'}>
            <Checkbox isChecked={Filtro.ativos} onChange={(e) => setFiltro({ ...Filtro, ativos: e.target.checked })}>Ativos</Checkbox>
            <Checkbox isChecked={Filtro.inativos} onChange={(e) => setFiltro({ ...Filtro, inativos: e.target.checked })}>Inativos</Checkbox>
            <Checkbox isChecked={Filtro.desligados} onChange={(e) => setFiltro({ ...Filtro, desligados: e.target.checked })}>Desligados</Checkbox>
          </Flex>

          <Flex gap={'1rem'} justifyContent='center'>
            <ButtonCmp VarColor='c6' onClick={onRequestClose}>Cancelar</ButtonCmp>
            <ButtonCmp
              VarColor='Green2'
              onClick={() => onConfirm(Filtro)}
              isLoading={isLoading}
              isDisabled={!Filtro.ativos && !Filtro.inativos && !Filtro.desligados}
            >Baixar</ButtonCmp>
          </Flex>
        </Flex>
      </Container>
    </Modal>
  )
}
